<div class="links-container">

    <!-- Existing link rows -->
    <div class="links-list">
        <div class="link-row" *ngFor="let link of links">
            <!-- Relation type badge -->
            <span class="relation-pill">
                {{ getLabelForType(link.linkType) | translate }}
            </span>

            <!-- Linked permit number -->
            <span class="id-pill">
                {{ getLinkedPermitDisplay(link) }}
            </span>

            <!-- Spacer -->
            <span class="link-spacer"></span>

            <!-- Delete button -->
            <button
                type="button"
                class="row-delete-btn"
                [matTooltip]="'permit.manage.links.delete_confirm' | translate"
                (click)="$event.stopPropagation(); confirmDelete(link)">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Add link area -->
    <div class="add-link-area">

        <!-- Trigger button -->
        <button
            type="button"
            class="add-link-btn"
            *ngIf="!isLinking"
            (click)="startLinking()">
            <mat-icon>add</mat-icon>
            {{ 'permit.manage.links.add' | translate }}
        </button>

        <!-- Search form -->
        <div class="link-search" *ngIf="isLinking">
            <div class="search-row">

                <!-- Link type selector -->
                <select
                    class="link-type-select"
                    [(ngModel)]="newLinkType"
                    name="newLinkType">
                    <option
                        *ngFor="let lt of linkTypes"
                        [value]="lt.value">
                        {{ lt.label | translate }}
                    </option>
                </select>

                <!-- Search input box -->
                <div class="search-input-box">
                    <mat-icon class="search-icon">search</mat-icon>
                    <mat-progress-spinner
                        *ngIf="isSearching"
                        mode="indeterminate"
                        diameter="16"
                        class="search-spinner">
                    </mat-progress-spinner>
                    <input
                        type="text"
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onSearch($event)"
                        [placeholder]="'permit.manage.links.search_placeholder' | translate"
                        (keydown.escape)="cancelLinking()">
                    <button
                        *ngIf="!isSearching && searchTerm"
                        type="button"
                        class="clear-btn"
                        (click)="clearSearch()">
                        <mat-icon>close</mat-icon>
                    </button>
                    <button
                        *ngIf="!isSearching && !searchTerm"
                        type="button"
                        class="clear-btn"
                        (click)="cancelLinking()">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Results dropdown -->
            <div class="search-dropdown" *ngIf="searchResults.length > 0 || (searchTerm.length >= 1 && !isSearching)">

                <div class="results-scroll" *ngIf="searchResults.length > 0">
                    <button
                        type="button"
                        class="search-option result-option"
                        *ngFor="let res of searchResults"
                        [disabled]="isCreating"
                        (click)="selectPermitToLink(res)">
                        <span class="res-id">{{ res.permitNumber || res.permitId }}</span>
                        <span class="res-main">
                            <span class="res-title">{{ localizedName(res.permitType?.name) }}</span>
                            <span class="res-external" *ngIf="res.externalPermitNumber">
                                {{ 'permit.manage.list.external_number' | translate }} {{ res.externalPermitNumber }}
                            </span>
                        </span>
                    </button>
                </div>

                <div
                    class="no-results"
                    *ngIf="searchTerm.length >= 1 && searchResults.length === 0 && !isSearching">
                    {{ 'permit.manage.links.empty' | translate }}
                </div>
            </div>
        </div>

    </div>

</div>
